/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Tour_Activity_BodyInputs */



/**
* | output |
* | --- |
* | "Mentions, invites and running syncs or embeddings show up here." |
*
* @param {Onboarding_Tour_Activity_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_tour_activity_body = /** @type {((inputs?: Onboarding_Tour_Activity_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Tour_Activity_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erwähnungen, Einladungen und laufende Synchronisationen oder Embeddings erscheinen hier.")
	return /** @type {LocalizedString} */ ("Mentions, invites and running syncs or embeddings show up here.")
});